import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';
import styled from 'styled-components';
import Badge from '../../../../Icons/Badge';

const Root = styled.div.withConfig({ componentId: 'sc-qk3ye-0' })`
  position: relative;
  height: 27px;
`;

interface Props {
  unreadChats: boolean;
  isChatShowing: boolean;
}

export default (props: Props) => {
  const { unreadChats, isChatShowing } = props;

  return (
    <Root>
      {unreadChats && <Badge />}
      <SvgIcon>
        <svg
          fill="none"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.246 1.00002C10.3328 0.997246 8.45372 1.50864 6.80377 2.48113C5.15383 3.45362 3.79313 4.85176 2.86287 6.53047C1.93261 8.20918 1.4667 10.1073 1.51348 12.0278C1.56026 13.9483 2.11803 15.8213 3.12891 17.4523L1 23L6.59598 20.9348C8.00766 21.8161 9.60387 22.3562 11.2588 22.5126C12.9138 22.6689 14.5823 22.4372 16.133 21.8358C17.6836 21.2343 19.0739 20.2795 20.1944 19.0465C21.3149 17.8136 22.135 16.3362 22.59 14.7308C23.045 13.1253 23.1225 11.4358 22.8165 9.79514C22.5104 8.15451 21.8291 6.60766 20.8262 5.27648C19.8234 3.94529 18.5264 2.86613 17.0374 2.12402C15.5485 1.38192 13.9082 0.997142 12.246 1.00002Z"
            stroke={isChatShowing ? '#0095AF' : 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M12 9V14.6569"
            stroke={isChatShowing ? '#0095AF' : 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M9.17157 11.8284H14.8284"
            stroke={isChatShowing ? '#0095AF' : 'currentColor'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </svg>
      </SvgIcon>
    </Root>
  );
};
